'use client'
import React from 'react'
import { Spinner, Text } from '../../../atoms'
import { GroupedSelectOption, TextTypes } from '../../../../types'

export const LoadingComponent = () => {
    return (
        <div className="flex justify-center">
            <Spinner />
        </div>
    )
}
export const formatGroupLabel = (group: GroupedSelectOption) => {
    return (
        <div className="border-b border-shade-200 pb-1 -mx-3">
            <Text type={TextTypes.SMALL_TEXT} className="normal-case text-xs px-3">
                {group.label}
            </Text>
        </div>
    )
}
